import './index.scss';

$(function ($) {
  const $component = $('.q-timeline-page');

  if ($component) {
    const $filter = $component.find('#js-timeline-filter');
    const $label = $filter.find('#timeline-filter-dropdown');
    const $form = $filter.find('#js-timeline-filter-form');

    $form.find('input[name="timeline-filter"]').change((e) => {
      let selectedValue = $(e.currentTarget).data('label');
      $($label).find('span').html(selectedValue);
      Turbolinks.visit($(e.currentTarget).data('url'));
    });

    $('.js-open-new-activity')
      .off('click')
      .on('click', event => {
        $component.find('.q-new-activity').removeClass('hidden');
        $(event.currentTarget).hide();
      });
  }
}(jQuery));
